import React from 'react';
import { Tag, Typography } from 'antd';
import type { RouteOperationalIntelligence } from './types';
import './routeHealthStrip.css';

const { Text } = Typography;

const HEALTH_COLORS: Record<string, string> = {
  HEALTHY: 'success',
  DELAYED: 'warning',
  STALLED: 'warning',
  BLOCKED: 'error',
  CRITICAL: 'error'
};

export type RouteHealthStripProps = {
  intelligence: RouteOperationalIntelligence;
  compact?: boolean;
};

export const RouteHealthStrip: React.FC<RouteHealthStripProps> = ({
  intelligence,
  compact = false
}) => {
  const { health, risks, eta, recommendations } = intelligence;
  const color = HEALTH_COLORS[health.state] ?? 'default';

  return (
    <section className={`route-health-strip route-health-strip--${health.state.toLowerCase()}`}>
      <div className="route-health-strip__head">
        <Text type="secondary">Состояние маршрута</Text>
        <Tag color={color}>{health.label}</Tag>
        {eta.delayRiskLabel ? <Tag color="warning">{eta.delayRiskLabel}</Tag> : null}
        {eta.slaBreachRisk ? <Tag color="error">Риск SLA</Tag> : null}
      </div>
      {!compact && health.summary ? (
        <div className="route-health-strip__summary">Причина: {health.summary}</div>
      ) : null}
      {risks.risks.length > 0 ? (
        <div className="route-health-strip__risks">
          <Text type="secondary">Риски:</Text>
          <ul>
            {risks.risks.slice(0, 4).map((r) => (
              <li key={r.code}>
                {r.title}
                {r.detail ? ` — ${r.detail}` : ''}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {!compact && recommendations.length > 0 ? (
        <div className="route-health-strip__recs">
          <Text type="secondary">Рекомендации:</Text>
          <ul>
            {recommendations.slice(0, 3).map((r) => (
              <li key={r.id}>{r.title}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {!compact && eta.expectedCompletionLabel ? (
        <div className="route-health-strip__eta">
          Ожидаемое завершение: {eta.expectedCompletionLabel}
          {eta.paceLabel ? ` · ${eta.paceLabel}` : ''}
        </div>
      ) : null}
    </section>
  );
};

export default RouteHealthStrip;
